module.exports = __webpack_public_path__ + "img/1391118220.be93f859.jpg";